import WholeProjectRow from 'components/widgets/WholeProjectRow/components/WholeProjectRow';
import { getColor } from 'utilitys/logicQualityCheck.utils';

export const WholeProjectRowComponent = ({ validation, row, columns, check }) => {
    if (!columns || columns.length < 1) {
        return null;
    }

    columns.forEach((column) => {
        if (column.colorable) {
            const rowValue = row[column.accessor];
            column.calculatedColor = getColor(rowValue, validation);
        }
    });

    return <WholeProjectRow row={row} columns={columns} check={check} />;
};
